import type { Product } from 'reactApp/types/Billing';
import { getMonthes, getPeriodName } from 'reactApp/utils/Period';

export function formatPrice(value?: number, locale = 'ru', ceil?: boolean, withNbsp = true): string {
    if (!value && value !== 0) {
        return '';
    }

    const price = Number(ceil ? Math.ceil(value) : value).toFixed(0);
    const formatedPrice = Number(price).toLocaleString(locale);
    if (withNbsp) {
        return formatedPrice;
    }
    return formatedPrice.replace('\u00A0', ' ');
}

export function formatWoNbspRuPrice(price: number) {
    return formatPrice(price, 'ru', undefined, false);
}

export function getMonthProductPrice(product, useDiscount = true) {
    const period = (useDiscount && product?.discountPeriod) || product.period;
    const months = getMonthes(period);
    const price = (useDiscount && product?.discountPrice) || product.price;

    return price / months;
}

export function getPriceStringWithPeriod(product: Product) {
    const { hasDiscount, discountPeriod, discountPrice, period, price } = product;
    const priceToDisplay = hasDiscount ? discountPrice : price;
    const periodToDisplay = hasDiscount && discountPeriod ? discountPeriod : period;

    return `${formatPrice(priceToDisplay)}\u00A0₽\u00A0в\u00A0${getPeriodName(periodToDisplay)}`;
}
